<template>
  <div class="userLayout" id="userLayout" :class="['user-layout-wrapper', device]">
    <div class="header-mobile">
      <div class="h-left">
        <a-icon type="menu-unfold" @click="drawVisible = true" />
        <img src="@/assets/logo.png" class="hover logo" @click="$router.push('/home')" />
      </div>
      <div class="h-right"></div>
    </div>
    <route-view></route-view>
    <ViewDraw :visible="drawVisible" @onclose="drawVisible = false" />
  </div>
</template>

<script>
import RouteView from './RouteView'
import { mixinDevice } from '@/utils/mixin'
import ViewDraw from './components/viewDraw'

export default {
  name: 'UserLayout',
  components: { RouteView, ViewDraw },
  mixins: [mixinDevice],
  data() {
    return {
      drawVisible: false
    }
  },
  mounted() {
    document.body.classList.add('userLayout')
  },
  beforeDestroy() {
    document.body.classList.remove('userLayout')
  }
}
</script>

<style lang="less" scoped>
.userLayout {
  .header-mobile {
    display: none;
  }
}
@media screen and (max-width: 960px) {
  .userLayout {
    .header-mobile {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px 17px;
      .h-left {
        display: flex;
        align-items: center;
        > img {
          height: 22px;
          margin-left: 6px;
        }
      }
      i {
        font-size: 24px;
      }
    }
  }
}
</style>
